import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  input,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
})
export class InputComponent implements OnInit, AfterViewInit, ControlValueAccessor {
  @Input() label?: string;
  @Input() help?: string;
  @Input() placeholder?: string;
  @Input() type?: string;
  @Input() prefix?: string;
  @Input() suffix?: string;
  @Input() pattern?: string;
  @Input() class?: string;
  @Input() hint?: string;
  @Input() error: { value: boolean, message?: string } = {
    value: false,
    message: undefined
  };
  @Input() bottomWrapper: boolean = false;
  @Input() disabled: boolean = false;
  @Input() autoFocus: boolean = false;

  min = input<number>()
  max = input<number>()

  public focus: boolean = false;
  private _pattern?: RegExp;

  shown: boolean = false;

  @Input() value: any = null;
  @Output() valueChange = new EventEmitter<any>();
  valueUpdate: Subject<any> = new Subject<any>();

  @Output() change = new EventEmitter<any>();

  @ViewChild("input") input?: ElementRef;

  // ControlValueAccessor — additive, coexists with [(value)] usages.
  private _onChange: (value: any) => void = () => {};
  private _onTouched: () => void = () => {};

  constructor() {
  }

  ngOnInit() {

    if (this.pattern) {
      this._pattern = new RegExp(this.pattern);
    }
    this.valueUpdate
      .pipe(debounceTime(100), distinctUntilChanged())
      .subscribe((value) => {
        this.valueChange.emit(this.value);
        this.change.emit(this.value);
        this._onChange(this.value);
      })
  }

  ngAfterViewInit(): void {
    if (this.input && this.autoFocus) {
      this.focus = true;
      this.input.nativeElement.focus();
    }
  }

  onBlur(): void {
    this.focus = false;
    this._onTouched();
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
